import { memo } from 'react';
import { buildHandleId } from '../../lib/utils';
import { HANDLES_TYPES } from '../../types';
import CustomNode from './CustomNode';
import HandlesWrapper from '../HandlesWrapper';
import styles from '../../timeline-node-manager.module.css';

const EventLinkNode = ({ id, data, type, selected }) => {
  return (
    <CustomNode
      id={id}
      data={data}
      label={`Link`}
      type={type}
      containerClassname={styles.conditionNode}
      selected={selected}
    >
      <HandlesWrapper
        targets={[
          {
            label: 'Target',
            id: buildHandleId({
              type: 'output',
              handleType: HANDLES_TYPES.EVENT_LINK,
              nodeId: id,
            }),
          },
        ]}
        sources={[
          {
            label: 'Source',
            id: buildHandleId({
              type: 'input',
              handleType: HANDLES_TYPES.EVENT,
              nodeId: id,
            }),
          },
        ]}
      />
    </CustomNode>
  );
};

export default memo(EventLinkNode);
